import React, { Component } from "react";
import RenderFormField from "./RenderFormField";
import { Row, Col } from "react-bootstrap";
import "./form-field.style.scss";

const customerInformationFields = [
  {
    name: "customer_id",
    type: "input",
    label: "CIF (Customer ID)",
  },
];

export default class CustomerInfoCorExisting extends Component {
  render() {
    const RenderCom = this.props.isView
      ? require("./RenderFormFieldView").default
      : RenderFormField;
    return (
      <div>
        <Row>
          <Col xs={12}>
            <p className="FormTitle">Customer Information (Existing to Bank)</p>
          </Col>
        </Row>
        <Row>
          {customerInformationFields.map((field) => (
            <Col key={field.name} xs={12} md={6}>
              <RenderCom {...field} formValues={this.props.formValues} />
            </Col>
          ))}
        </Row>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// src/pages/Pricing/NewPricing/components/CustomerInfoCorExisting.js